module.exports = new __parcel__URL__("view_mission_btn.43ef599a.png").toString();